// extracted by mini-css-extract-plugin
export default {"rowContainer":"styles_rowContainer__4s90Y","title":"styles_title__mxXrB","subtitle":"styles_subtitle__aFrFY","twoLinesHeader":"styles_twoLinesHeader__fBTiP"};